import React from "react";
import { moment } from "../common/common";

export default class CarRegisterInfo extends React.Component {
	constructor(props) {
		super(props);

		var i;
		const seats = [];
		for (i = 4; i <= 20; ++i) {
			seats.push(i);
		}

		const years = [];
		const curYear = moment().year();
		for (i = curYear; i >= 1960; --i) {
			years.push(i);
		}

		this.state = {
			seats: seats,
			years: years,
		};
	}

	componentDidMount() {
		window.scrollTo(0, 0);
	}

	componentDidUpdate(preProps) {
		if (preProps.fuel !== this.props.fuel) {
			this.setState({
				fuel: this.props.fuel
			})
		}
	}

	onInviteCodeChange = (event) => {
		this.props.onInviteCodeChange(event);
	};

	onLicensePlateChange = (event) => {
		this.props.onLicensePlateChange(event);
	};

	onVehicleTypeChange = (event) => {
		this.props.onVehicleTypeChange(event);
	};

	onVehicleMakeChange = (event) => {
		this.props.onVehicleMakeChange(event);
	};

	onVehicleModelChange = (event) => {
		this.props.onVehicleModelChange(event);
	};

	onYearChange = (event) => {
		this.props.onYearChange(event);
	};

	onSeatChange = (event) => {
		this.props.onSeatChange(event);
	};

	onTransmisionChange = (event) => {
		this.props.onTransmisionChange(event);
	};

	onFuelChange = (event) => {
		this.props.onFuelChange(event);
	};

	onFuelRateChange = (event) => {
		this.props.onFuelRateChange(event);
	};

	onDescChange = (event) => {
		this.props.onDescChange(event);
	};

	onFeaturesChange = (event) => {
		this.props.onFeaturesChange(event);
	};

	render() {
		const { fuel } = this.state; 
		return (
			<div className="group form-default">
				{/* <h6>Mã giới thiệu</h6>
            <p className="fl"><span className="note">Nếu bạn nhận được mã giới thiệu để đăng kí xe, vui lòng nhập vào ô bên dưới.</span></p>
            <div className="space m"/>
            <div className="space m"/>
            <div className="col-left">
                <div className="line-form">
                    <div className="wrap-input">
                        <input type="text" onChange={this.onInviteCodeChange} value={this.props.inviteCode} />
                    </div>
                </div>
            </div>
            <div className="space m clear"/>
            <div className="clear"/> */}
				<h6>Biển số xe</h6>
				<p className="fl">
					<span className="note" style={{ color: "red" }}>
						Lưu ý: Biển số sẽ không thể thay đổi sau khi đăng kí.
					</span>
				</p>
				<div className="space m" />
				<div className="space m" />
				<div className="col-left">
					<div className="line-form">
						<div className="wrap-input">
							<input type="text" onChange={this.onLicensePlateChange} value={this.props.licensePlate} />
						</div>
					</div>
				</div>
				<div className="space m clear" />
				<div className="clear"></div>
				<h6>Thông tin cơ bản</h6>
				<p className="fl">
					<span className="note" style={{ color: "red" }}>
						Lưu ý: Các thông tin cơ bản sẽ không thể thay đổi sau khi đăng kí.
					</span>
				</p>
				<div className="space clear"></div>
				<div className="col-left">
					<div className="line-form">
						<label className="label">Hãng xe</label>
						<span className="wrap-select">
							<select onChange={this.onVehicleMakeChange} value={this.props.vehicleMake}>
								<option value="0">Chọn hãng xe</option>
								{this.props.vehicleMakes &&
									this.props.vehicleMakes.map((option) => (
										<option key={option.id} value={option.id}>
											{option.name}
										</option>
									))}
							</select>
						</span>
					</div>
				</div>
				<div className="col-right">
					<div className="line-form">
						<label className="label">Mẫu xe</label>
						<span className="wrap-select">
							<select
								disabled={!this.props.vehicleMake || this.props.vehicleMake === 0}
								onChange={this.onVehicleModelChange}
								value={this.props.vehicleModel}>
								<option value="0">
									{!this.props.vehicleMake || this.props.vehicleMake === 0 ? "Chọn hãng xe trước" : "Chưa chọn"}
								</option>
								{this.props.vehicleModels &&
									this.props.vehicleModels.map((option) => (
										<option key={option.id} value={option.id}>
											{option.name}
										</option>
									))}
							</select>
						</span>
					</div>
				</div>
				<div className="space clear" />
				<div className="col-left">
					<div className="line-form">
						<label className="label">Số ghế</label>
						<span className="wrap-select">
							<select onChange={this.onSeatChange} value={this.props.seat}>
								{this.state.seats.map((seat) => (
									<option key={seat} value={seat}>
										{seat}
									</option>
								))}
							</select>
						</span>
					</div>
				</div>
				<div className="col-right">
					<div className="line-form">
						<label className="label">Năm sản xuất</label>
						<span className="wrap-select">
							<select onChange={this.onYearChange} value={this.props.year}>
								{this.state.years.map((year) => (
									<option key={year} value={year}>
										{year}
									</option>
								))}
							</select>
						</span>
					</div>
				</div>
				<div className="space clear" />
				<div className="col-left">
					<div className="line-form">
						<label className="label">Truyền động</label>
						<span className="wrap-select">
							<select onChange={this.onTransmisionChange} value={this.props.transmision}>
								<option value="1">Số tự động</option>
								<option value="2">Số sàn</option>
							</select>
						</span>
					</div>
				</div>
				<div className="col-right">
					<div className="line-form">
						<label className="label">Loại nhiên liệu</label>
						<span className="wrap-select">
							<select onChange={this.onFuelChange} value={this.props.fuel}>
								<option value="1">Xăng</option>
								<option value="2">Dầu diesel</option>
								<option value="3">Điện</option>
							</select>
						</span>
					</div>
				</div>
				<div className="space m" />
				<div className="space clear" />
				<h6>Mức tiêu thụ nhiên liệu</h6>
					<p className="fl">
						<span className="note">{fuel === "3" ? 'Số km đi được trong một lần sạc đầy.' : 'Số lít nhiên liệu cho quãng đường 100km.'}</span>
					</p>
				<div className="clear" />
				<div className="col-left">
					<div className="line-form">
						<label className="label" />
						<div className="wrap-input">
							<input type="text" placeholder="" onChange={this.onFuelRateChange} value={this.props.fuelRate} />
						</div>
					</div>
				</div>
				<div className="space clear" />
				<h6>Mô tả</h6>
				<div className="custom-textarea">
					<textarea
						className="textarea"
						onChange={this.onDescChange}
						placeholder="Huyndai Elantra số tự động đăng kí tháng 06/2018. Xe gia đình mới đẹp, nội thất nguyên bản, sạch sẽ, bảo dưỡng thường xuyên, rửa xe miễn phí cho khách. Xe rộng rãi, an toàn, tiện nghi, phù hợp cho gia đình du lịch. Xe trang bị hệ thống cảm biến lùi, gạt mưa tự động, đèn pha tự động, camera hành trình, hệ thống giải trí AV cùng nhiều tiện nghi khác..."
						value={this.props.desc}></textarea>
				</div>
				<div className="space m" />
				<h6>Tính năng</h6>
				<div className="car-feature__sect">
					<div className="list-feature">
						{this.props.featuresAll &&
							this.props.featuresAll.map((option) => {
								return (
									<div className="squaredThree have-label" key={option.id}>
										<input
											id={option.id}
											type="checkbox"
											checked={option.checked ? true : false}
											value={option.id}
											onChange={this.onFeaturesChange}
											name="filter-car-feature"
										/>
										<label className="description" htmlFor={option.id}>
											<div className="thumbnail">
												<img loading="lazy" className="img-fluid" src={option.logo} alt={option.name} />
												<span style={{ fontSize: ".875rem" }}>{option.name}</span>
											</div>
										</label>
									</div>
								);
							})}
					</div>
				</div>
				{/* <div className="list-features">
                <ul>
                    {this.props.featuresAll && this.props.featuresAll.map(option => <li key={option.id}>
                        <div className="squaredFour have-label">
                            <input id={`${option.id}`} type="checkbox" checked={option.checked ? true : false} value={option.id} onChange={this.onFeaturesChange} />
                            <label htmlFor={`${option.id}`}> <img style={{ width: "16px", height: "16px" }} className="img-ico" src={option.logo} alt="Mioto - Thuê xe tự lái" /> {option.name}</label>
                        </div>
                    </li>)}
                </ul>
            </div> */}
			</div>
		);
	}
}
